import { X, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PrepaidModal({ 
  customer, 
  action, 
  setAction, 
  amount, 
  setAmount, 
  onSubmit, 
  onClose 
}) {
  if (!customer) return null;

  const handleClose = () => {
    setAmount("");
    setAction("add");
    onClose();
  };

  const newBalance = action === "add" 
    ? ((customer.prepaid_balance || 0) + parseFloat(amount || 0)).toFixed(2)
    : Math.max(0, (customer.prepaid_balance || 0) - parseFloat(amount || 0)).toFixed(2);

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-sm shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-lg">💰 Prépaiement</h3>
          <Button variant="ghost" size="icon" onClick={handleClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="p-4">
          <div className="mb-4 p-3 bg-slate-50 rounded-lg">
            <p className="font-medium">{customer.first_name} {customer.last_name}</p>
            <p className="text-sm text-slate-500">
              Solde actuel: <strong className="text-emerald-600">{(customer.prepaid_balance || 0).toFixed(2)}€</strong>
            </p>
          </div>
          
          <div className="mb-4">
            <Label>Action</Label>
            <div className="flex gap-2 mt-1">
              <Button
                type="button"
                variant={action === "add" ? "default" : "outline"}
                onClick={() => setAction("add")}
                className={action === "add" ? "bg-green-600 hover:bg-green-700 flex-1" : "flex-1"}
              >
                + Ajouter
              </Button>
              <Button
                type="button"
                variant={action === "remove" ? "default" : "outline"}
                onClick={() => setAction("remove")}
                className={action === "remove" ? "bg-red-600 hover:bg-red-700 flex-1" : "flex-1"}
              >
                - Déduire
              </Button>
            </div>
          </div>
          
          <div className="mb-4">
            <Label>Montant (€)</Label>
            <Input
              type="number"
              step="0.01"
              min="0.01"
              max={action === "remove" ? (customer.prepaid_balance || 0).toFixed(2) : 1000}
              placeholder="Ex: 5.00"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="mt-1"
              autoFocus
            />
          </div>
          
          {amount && parseFloat(amount) > 0 && (
            <div className={`mb-4 p-3 rounded-lg text-sm ${action === "add" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>
              <p>
                Après cette opération: <strong>{newBalance}€</strong>
              </p>
            </div>
          )}
          
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={handleClose}>
              Annuler
            </Button>
            <Button 
              onClick={onSubmit} 
              disabled={!amount || parseFloat(amount) <= 0 || (action === "remove" && Math.round(parseFloat(amount) * 100) > Math.round((customer.prepaid_balance || 0) * 100))}
              className={action === "add" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"}
            >
              <Check className="w-4 h-4 mr-1" />
              {action === "add" ? "Ajouter" : "Déduire"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
